import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { LocalStorage } from 'ngx-store';

//Model
import { Repair, RepairRequest, DamageReport, Service,RepairRequestChange,CancelPairing } from '../model/maintenance.model';
import { Url } from '../model/users.model';

@Injectable()
export class MaintenanceService {
  @LocalStorage() url: Url;

  private headers = new Headers({ 'Content-Type': 'application/json' });
  
    // Http Headers
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }

    constructor(public http:HttpClient) { 
    }

  getMaintenanceData() {
        return this.http.get(this.url.rest  + '/tms/getMaintenanceData', this.httpOptions)
          .pipe(
            retry(1),
            catchError(this.handleError)
          )    
  }


  getRepairs(filter = '', start = '', end = ''): Observable<Repair[]> { 
    if (filter) {
      filter = '/' + filter; 
      if (filter == '/range' && start != '' && end != '')
      // if (start == end){
      //   filter = '/range'
      // }
      // else{
        filter = '/range/' + start + '/' + end; 
      // }
    } else filter = '';
    return this.http.get<Repair[]>(this.url.rest  + '/tms/getRepairs'+ filter, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
    )  
  }

  getRepairsByFleetId(fleetId, filter = '', start = '', end = ''): Observable<Repair[]> { 
    if (filter) {
      filter = '/' + filter; 
      if (filter == '/range' && start != '' && end != '')
      // if (start == end){
      //   filter = '/range'
      // }
      // else{
        filter = '/range/' + start + '/' + end; 
      // }
    } else filter = '';
    console.log('/tms/fleetdetails/getRepairsByFleetId/',fleetId,filter)
    return this.http.get<Repair[]>(this.url.rest  + '/tms/fleetdetails/getRepairsByFleetId/' + fleetId + filter, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
    }
  
  getRepairRequests(): Observable<RepairRequest[]> { 
    return this.http.get<RepairRequest[]>(this.url.rest  + '/tms/getRequests', this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  getDamageReports(): Observable<DamageReport[]> { 
    return this.http.get<DamageReport[]>(this.url.rest  + '/tms/getDamages', this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  getServices(filter = '', start = '', end = ''): Observable<Service[]> { 
    if (filter) {
      filter = '/' + filter; 
      if (filter == '/range' && start != '' && end != '')
      // if (start == end){
      //   filter = '/range'
      // }
      // else{
        filter = '/range/' + start + '/' + end; 
      // }
    } else filter = '';
  return this.http.get<Service[]>(this.url.rest  + '/tms/getServices' + filter, this.httpOptions)
    .pipe(
      retry(1),
      catchError(this.handleError)
    ) 
  }

  getServicesByFleetId(fleetId, filter = '', start = '', end = ''): Observable<Service[]> { 
    if (filter) {
      filter = '/' + filter; 
      if (filter == '/range' && start != '' && end != '')
      // if (start == end){
      //   filter = '/range'
      // }
      // else{
        filter = '/range/' + start + '/' + end; 
      // } 
    } else filter = '';
    return this.http.get<Service[]>(this.url.rest  + '/tms/fleetdetails/getServicesByFleetId/' + fleetId + filter, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
    }



    createRepair(repair:Repair): Observable<Repair> {	
      return this.http.post<Repair>(this.url.rest  + '/tms/createRepair', repair , this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        ) 
    }

    updateRepair(repair: Repair): Observable<Repair> {
      return this.http.post<Repair>(this.url.rest  + '/tms/updateRepair', repair , this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        ) 
    }

    deleteRepair(id: number) {
      return this.http.delete(this.url.rest  + '/tms/deleteRepair/' + id);
    }   



    createRepairRequest(repairRequest:RepairRequest): Observable<RepairRequest> {	
        return this.http.post<RepairRequest>(this.url.rest  + '/tms/createRepairRequest', repairRequest , this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        ) 
      }
  
    updateRepairRequest(repairRequest: RepairRequest): Observable<RepairRequest> {
        return this.http.post<RepairRequest>(this.url.rest  + '/tms/updateRepairRequest', repairRequest , this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        ) 
    }
  
      deleteRepairRequest(id: number) {
        return this.http.delete(this.url.rest  + '/tms/deleteRepairRequest/' + id);
      }   

    createDamageReport(damageReport:DamageReport): Observable<DamageReport> {	
        return this.http.post<DamageReport>(this.url.rest  + '/tms/createDamageReport', damageReport , this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        ) 
    }

    createDamageReportSample(damageReport:DamageReport): Observable<DamageReport> {	
      return this.http.post<DamageReport>(this.url.rest  + '/tms/createDamageReportSample', damageReport , this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      ) 
  } 
    updateDamageReport(damageReport:DamageReport): Observable<DamageReport> {
      return this.http.post<DamageReport>(this.url.rest  + '/tms/updateDamageReport', damageReport, this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        ) 
    }

    updateDamageReportSample(damageReport:DamageReport): Observable<DamageReport> {
      return this.http.post<DamageReport>(this.url.rest  + '/tms/updateDamageReportSample', damageReport, this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        ) 
    }

    deleteDamageReport(id: number) {
      return this.http.delete(this.url.rest  + '/tms/deleteDamageReport/' + id);
    }   

    createService(service:Service): Observable<Service> {	
        return this.http.post<Service>(this.url.rest  + '/tms/createService', service , this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        ) 
      }
  
    updateService(service: Service): Observable<Service> {
        return this.http.post<Service>(this.url.rest  + '/tms/updateService', service , this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        ) 
    }
  
    deleteService(id: number) {
        return this.http.delete(this.url.rest  + '/tms/deleteService/' + id);
    } 
    
    getMaintenanceMisc() {
      return this.http.get(this.url.rest  + '/tms/getMaintenanceMisc', this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        )
    }

    getServiceSummary() {
      return this.http.get(this.url.rest  + '/tms/fleetdetails/getServiceSummary', this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        )
    }

    getServiceSummaryByFleetId(fleet_id) {
      return this.http.get(this.url.rest  + '/tms/fleetdetails/getServiceSummaryByFleetId/' + fleet_id, this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        )
    }

    getRepairsSummary() {
      return this.http.get(this.url.rest  + '/tms/fleetdetails/getRepairsSummary', this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        )
    }

    getRepairsSummaryByFleetId(fleet_id) {
      return this.http.get(this.url.rest  + '/tms/fleetdetails/getRepairsSummaryByFleetId/' + fleet_id, this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        )
    }

    createRepairRequestChanges(repairChange:RepairRequestChange): Observable<RepairRequestChange> {	
      return this.http.post<RepairRequestChange>(this.url.rest  + '/tms/createRepairRequestSample', repairChange , this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        ) 
    }

    updateRepairRequestChanges(repairChange: RepairRequestChange): Observable<RepairRequestChange> {
      return this.http.post<RepairRequestChange>(this.url.rest  + '/tms/updateRepairRequestSample', repairChange , this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      ) 
  }

  cancelSelectedRepairRequest(cancel: CancelPairing) {
    return this.http.post<CancelPairing>(this.url.rest  + '/tms/cancelSelectedRepairRequest',cancel , this.httpOptions)
    .pipe(
      retry(1),
      catchError(this.handleError)
    ) 
}

  cancelRepairRequest(id: number) {
    return this.http.delete(this.url.rest  + '/tms/cancelRepairRequest/' + id);
  }   

    getPairingsById(id:number) { 
      return this.http.get(this.url.rest + '/tms/getPairingsById/' + id, this.httpOptions)
          .pipe(
              retry(1),
              catchError(this.handleError)
          )    
  }

  getDataById(id:number) { 
    return this.http.get(this.url.rest + '/tms/getDataById/' + id, this.httpOptions)
        .pipe(
            retry(1),
            catchError(this.handleError)
        )    
  }

  getRRPByID(id:number) { 
    return this.http.get(this.url.rest + '/tms/getRRPByID/' + id, this.httpOptions)
        .pipe(
            retry(1),
            catchError(this.handleError)
        )    
  }

  createRepairSample(repair:Repair): Observable<Repair> {	
    return this.http.post<Repair>(this.url.rest  + '/tms/createRepairSample', repair , this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      ) 
  }

  // Error handling
  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }
}